import { useMemo } from 'react'

import { useLayoutEditorContext } from 'features/views/LayoutEditor/useLayoutEditorContext'
import {
    PipelineWidgetFieldRef,
    PipelineWidgetStageData,
} from 'features/views/LayoutEditor/widgets/PipelineWidget/types'
import { useRecordManagerContext } from 'features/views/RecordManager/useRecordManagerContext'

export function useDescriptionAttributeState(item: PipelineWidgetStageData) {
    const { fields } = useLayoutEditorContext()
    const { record, isLoadingSlow } = useRecordManagerContext()

    const stageDescription = item.stage.description
    const field =
        typeof stageDescription === 'string'
            ? undefined
            : fields?.find(
                  (f) => f.api_name === (stageDescription as PipelineWidgetFieldRef).fieldApiName
              )
    const value =
        typeof stageDescription === 'string'
            ? stageDescription
            : (record?.[field?.api_name!] ?? undefined)

    return useMemo(
        () => ({
            field,
            value,
            isLoading: isLoadingSlow,
        }),
        [field, value, isLoadingSlow]
    )
}
